const awsConfiguration = {
  region: 'ap-northeast-1',
  IdentityPoolId: 'ap-northeast-1:97355ccb-2192-4c2c-9be5-fa0d250c70d9',
  UserPoolId: 'ap-northeast-1_PEEXygKaK',
  ClientId: '4ljvc9cucnrh4p09pqhe2iepj3'
};

export default awsConfiguration;
